import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as RouterActions from 'connected-react-router';

import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(() => ({
    container: {
        maxWidth: '600px',
        width: '100%',
        margin: '1rem auto',
        padding: '2rem',
        textAlign: 'center',
        position: 'relative'
    },
    buttonContainer: {
        '& > :last-child': {
            marginLeft: '2rem'
        }
    }
}));

const LoginLanding = ({ push }) => {
    const classes = useStyles();
    return (
        <Paper className={classes.container}>
            <h2>Are you requesting access for a country in the EU?</h2>
            <div className={classes.buttonContainer}>
                <Button variant='contained' color='primary' onClick={() => push('/country-questionnaire')}>I need EU access</Button>
                <Button variant='contained' color='primary' onClick={() => push('/region-questionnaire')}>I do not need EU access</Button>
            </div>
        </Paper>
    );
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        push: RouterActions.push
    }, dispatch);
};

LoginLanding.propTypes = {
    push: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(LoginLanding);
